import { downloadBase64File } from "../../../../../common/utils/download_utils";
import { ReportMimeType } from "../../../../../common/utils/report_callback";
import { IGetReportColetaPrecoUseCase } from "../../../presentation/useCases/read/get_report_coleta_preco_use_case";
import { ReportData } from "../../models/report_data";
import { IReportsRepository } from "../../repositories/reports_repository";

import dayjs from "dayjs";

/**
 * GetReportColetaUseCase
 */

export class GetReportColetaPrecoUseCase implements IGetReportColetaPrecoUseCase {
  constructor(private readonly repository: IReportsRepository) { }

  async getReportColetaPreco(
    requiredMimeType: ReportMimeType | null,
    idColetaPreco: number,
  ): Promise<ReportData> {
    const response = await this.repository.getReportColetaPreco(
      requiredMimeType,
      idColetaPreco,
    );

    if (response.mimeType !== 'text/html') {
      const arquivoData = response.bytes;
      const arquivoNome = `coleta_preco_${dayjs(new Date()).format('DD_MM_YYYY_HH_mm_ss')}.${response.filenameExtension}`

      await downloadBase64File(arquivoNome, arquivoData);
    }
    return response;
  }
}
